"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../SharedButton.scss");
require("./NavigationButton.scss");
const ButtonProps_1 = require("../ButtonProps");
/**
 * Use a NavigationButton where the action will relate to a navigational action.
 * I.e. the opening of a form, the saving of a form
 */
const NavigationButton = (props) => {
    const handleClick = (event) => {
        props.disabled !== true && props.action();
    };
    return (react_1.default.createElement("button", { className: `ff-component-navigation-button ${props.className} ${props.disabled ? "ff-button-disabled" : "clickable"} ${props.type || ButtonProps_1.ButtonType.Primary} ${props.size}`, onClick: handleClick, ref: props.myRef, type: "button" },
        react_1.default.createElement("span", { className: "displayFix" }, props.children)));
};
exports.default = NavigationButton;
//# sourceMappingURL=NavigationButton.js.map